<template>
  <div :style="{ background: `url(${bg})`, backgroundSize: 'cover', height: '100%', padding: '100px' }">
    <div v-if="isLogin" class="login-wrap animate__animated animate__fadeInDown">
      <div class="login-inner">
        <a-dropdown :trigger="['click']">
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            <svg t="1717551059438" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4459" width="30" height="40"><path d="M757.205333 473.173333c5.333333 0 10.453333 2.090667 14.250667 5.717334a19.029333 19.029333 0 0 1 5.888 13.738666v58.154667h141.184c11.093333 0 20.138667 8.704 20.138667 19.413333v232.704a19.797333 19.797333 0 0 1-20.138667 19.413334h-141.184v96.981333a19.754667 19.754667 0 0 1-20.138667 19.370667H716.8a20.565333 20.565333 0 0 1-14.250667-5.674667 19.029333 19.029333 0 0 1-5.888-13.696v-96.981333h-141.141333a20.565333 20.565333 0 0 1-14.250667-5.674667 19.029333 19.029333 0 0 1-5.930666-13.738667v-232.704c0-5.12 2.133333-10.112 5.930666-13.738666a20.565333 20.565333 0 0 1 14.250667-5.674667h141.141333v-58.154667c0-5.162667 2.133333-10.112 5.888-13.738666a20.565333 20.565333 0 0 1 14.250667-5.674667h40.362667zM192.597333 628.394667c22.272 0 40.32 17.365333 40.32 38.826666v38.741334c0 40.618667 32.512 74.368 74.624 77.397333l6.058667 0.213333h80.64c21.930667 0.469333 39.424 17.706667 39.424 38.784 0 21.077333-17.493333 38.314667-39.424 38.784H313.6c-89.088 0-161.28-69.461333-161.28-155.178666v-38.741334c0-21.461333 18.005333-38.826667 40.277333-38.826666z m504.106667 0h-80.64v116.394666h80.64v-116.394666z m161.28 0h-80.64v116.394666h80.64v-116.394666zM320.170667 85.333333c8.234667 0 15.658667 4.778667 18.773333 12.202667H338.773333l161.322667 387.84c2.517333 5.973333 1.706667 12.8-2.005333 18.090667a20.394667 20.394667 0 0 1-16.725334 8.533333h-43.52a20.181333 20.181333 0 0 1-18.688-12.202667L375.850667 395.648H210.901333l-43.264 104.149333A20.181333 20.181333 0 0 1 148.906667 512H105.514667a20.394667 20.394667 0 0 1-16.725334-8.533333 18.773333 18.773333 0 0 1-2.005333-18.090667l161.28-387.84A20.181333 20.181333 0 0 1 266.88 85.333333h53.290667zM716.8 162.901333c42.794667 0 83.84 16.341333 114.090667 45.44a152.234667 152.234667 0 0 1 47.232 109.738667v38.741333c-0.469333 21.077333-18.389333 37.930667-40.32 37.930667s-39.808-16.853333-40.32-37.930667v-38.741333c0-20.608-8.490667-40.32-23.637334-54.869333a82.304 82.304 0 0 0-57.045333-22.741334h-80.64c-21.888-0.469333-39.424-17.706667-39.424-38.784 0-21.077333 17.493333-38.314667 39.424-38.784h80.64z m-423.424 34.304L243.2 318.037333h100.48L293.418667 197.205333z" fill="#666" p-id="4460"></path></svg>
          </a>
          <a-menu slot="overlay">
            <a-menu-item :disabled="lang === 'zh'" key="zh" @click="changeLang('zh')">
              <a :class="{ disabled: lang === 'zh' }">中文</a>
            </a-menu-item>
            <a-menu-item :disabled="lang === 'en'" key="en" @click="changeLang('en')">
              <a :class="{ disabled: lang === 'en' }">Engilsh</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <div class="login-title">
          <h2>{{ $t('login.title') }}</h2>
        </div>
        <a-form-model :model="loginParam" style="position: relative">
          <a-form-model-item style="margin-bottom: 8px;" prop="username">
            <a-input ref="username" v-model="loginParam.username" :placeholder="$t('login.username')" @keyup.enter="login(isCodeShow)"/>
          </a-form-model-item>
          <a-form-model-item style="margin-bottom: 8px;" prop="password">
            <a-input-password
              v-model="loginParam.password"
              :placeholder="$t('login.password')"
              @keyup.enter="login(isCodeShow)"
              @change="changePassword"
              :suffix="null"/>
          </a-form-model-item>
          <a-form-model-item v-show="isCodeShow">
            <div style="width: 100%; display: flex;">
              <a-input v-model="loginParam.captcha" :placeholder="$t('messages.pev')"></a-input>
              <a-button type="primary" style="margin-left: 10px;" :disabled="disabled" @click="getCaptcha">{{disabled ? `${i} ${$t('login.getLater')}` : ''}} {{ $t('login.getCaptcha').toLowerCase() }}</a-button>
            </div>
          </a-form-model-item>
          <a-checkbox style="margin-bottom: 8px;" :checked="remember" @change="changeRemember">{{ $t('login.r') }}</a-checkbox>
          <a-form-model-item style="position: relative" v-if="lang === 'zh'">
            <a-button type="link" style="position: absolute; left: 226px; top: -10px" @click="isLogin = false">
              {{ $t('login.forgetPassword') }}?
            </a-button>
          </a-form-model-item>
          <a-form-model-item style="margin-bottom: 8px;">
            <a-button v-if="isCodeShow" type="primary" @click="() => login(true)" block>{{ $t('login.title') }}</a-button>
            <a-button v-else type="primary" @click="() => login(false)" block>{{ $t('login.button') }}</a-button>
          </a-form-model-item>
        </a-form-model>
        <!-- <a-modal v-model="visible" title="消息确认框" cancelText="否" okText="是" @ok="handleOk" @cancel="handleCancel">
          <p>是否信任此浏览器，信任后下次登录将不再需要验证码</p>
        </a-modal> -->
      </div>
    </div>
    <div v-else class="login-wrap animate__animated animate__fadeInDown">
      <div class="login-inner">
        <div class="login-title">
          <h2>{{ $t('login.resetPassword') }}</h2>
        </div>
        <a-form-model :model="resetParam">
          <a-form-model-item style="margin-bottom: 8px;" prop="username">
            <a-input ref="username" v-model="resetParam.mobile" :placeholder="$t('login.username')" @keyup.enter="login"/>
          </a-form-model-item>
          <a-form-model-item style="margin-bottom: 8px;" prop="password">
            <a-input-password
              :autocomplete="false"
              v-model="resetParam.newPassword"
              :placeholder="$t('login.password')"
              :suffix="null"/>
          </a-form-model-item>
          <a-form-model-item>
            <div style="width: 100%; display: flex;">
              <a-input v-model="resetParam.captcha" placeholder="请输入验证码"></a-input>
              <a-button type="primary" style="margin-left: 10px;" :disabled="disabled1" @click="getCaptcha1">{{disabled1 ? `${i1}${$t('login.getLater')}` : ''}}{{ $t('login.getCaptcha') }}</a-button>
            </div>
          </a-form-model-item>
          <!-- <a-checkbox style="margin-bottom: 8px;" :checked="remember" @change="changeRemember">记住用户</a-checkbox> -->
          <a-form-model-item style="position: relative">
            <a-button type="link" style="position: absolute; left: 226px; top: -10px" @click="isLogin = true">
              {{ $t('login.returnLogin') }}
            </a-button>
          </a-form-model-item>
          <a-form-model-item style="margin-bottom: 8px;">
            <a-button type="primary" block @click="resetP">{{ $t('login.resetPassword') }}</a-button>
          </a-form-model-item>
        </a-form-model>
        <!-- <a-modal v-model="visible" title="消息确认框" cancelText="否" okText="是" @ok="handleOk" @cancel="handleCancel">
          <p>是否信任此浏览器，信任后下次登录将不再需要验证码</p>
        </a-modal> -->
      </div>
    </div>
    <div class="footer">
      ©2024 deman.cn&nbsp;&nbsp;&nbsp;&nbsp;版权所有&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2020037887号-4</a>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import {
  isRequiredCaptcha,
  login,
  sendResetCaptcha,
  updatePassword
} from '@/api/auth'
import url from '@/assets/bg.png'
import { encrypt, decrypt } from '@/plugins/encrypt'
import axios from 'axios'
import { createFormData } from '@/plugins/formData'

const sendCaptcha = axios.create({
  baseURL: 'https://ygk.deman.cn/api/v2/auth',
  // baseURL: 'http://10.55.50.85:10000/api/auth',
  // baseURL: 'http://10.55.50.87:10000/api/auth',
  timeout: '60 * 1000'
})

export default {
  name: 'index',
  mounted () {
    this.$nextTick(() => {
      this.$refs.username.focus()
    })
    const username = localStorage.getItem('username')
    if (username) {
      this.loginParam.username = username
      this.mp = this.loginParam.username
      const p = localStorage.getItem('password')
      if (p) {
        this.loginParam.password = decrypt(localStorage.getItem('password'))
      }
      this.isEncrypt = true
    }
  },
  data () {
    return {
      remember: true,
      spaceSize: 15,
      loginParam: {
        username: '',
        password: '',
        captcha: ''
      },
      newPassword: '',
      resetParam: {
        mobile: '',
        newPassword: '',
        captcha: ''
      },
      bg: url,
      isEncrypt: false,
      disabled: false,
      i: 60,
      isCodeShow: false,
      mp: '',
      visible: false,
      title: '登录',
      isLogin: true,
      disabled1: false,
      i1: 60,
      lang: localStorage.getItem('lang') || 'zh'
    }
  },
  created() {
    this.validateCode = true
  },
  methods: {
    async login (withCaptcha) {
      if(!this.loginParam.username) {
        return this.$message.warning(this.$t('messages.peymn'))
      }
      if(!this.loginParam.password) {
        return this.$message.warning(this.$t('messages.peyp'))
      }
      if(withCaptcha && !this.loginParam.captcha) {
        return this.$message.warning(this.$t('messages.pev'))
      }
      if (!withCaptcha) {
        const result = await isRequiredCaptcha(this.loginParam.username)
        if (result.data) {
          this.isCodeShow = true
          return this.$message.warning(this.$t('messages.turac'))
        }
      }
      const param = {
        username: this.loginParam.username,
        password: this.loginParam.password,
        captcha: this.loginParam.captcha
      }
      try {
        const { data: { data, code, message } } = await sendCaptcha({
          url: '/login',
          method: 'POST',
          data: createFormData(param)
        })
        if (code === 1002) {
          return this.$message.error(this.$t('messages.wp'))
        }
        if (code === 1004) {
          return this.$message.error(message)
        }
        if (code === 1103) {
          return this.$message.error(message)
        }
        localStorage.setItem('menus', JSON.stringify(data.menus))
        localStorage.setItem('token', JSON.stringify(data.accessToken.value))
        localStorage.setItem('rToken', JSON.stringify(data.refreshToken.value))
        localStorage.setItem('nick', data.user.realName)
        localStorage.setItem('logo', data.user.logo || '')
        localStorage.setItem('userId', data.user.id)
        localStorage.setItem('start', +new Date())
        if (this.remember) {
          localStorage.setItem('username', this.loginParam.username)
          localStorage.setItem('password', encrypt(this.loginParam.password))
        }
        this.$router.push('/')
      } catch(e) {
        console.log(e)
      }
      // if (localStorage.getItem('isTrusted') !== 'y' && this.isCodeShow) {
      //   this.visible = true
      // } else {
      //   this.$router.push('/')
      //   this.$message.success('登录成功', 1)
      // }
      // if(!this.loginParam.code && this.isCodeShow) {
      //   return this.$message.warning('请输入验证码')
      // }
      // if (this.remember) {
      //   const userInfo = { username: '', password: '' }
      //   userInfo.username = window.btoa(this.loginParam.username)
      //   userInfo.password = this.isEncrypt ? this.loginParam.password : encrypt(this.loginParam.password)
      //   localStorage.setItem('user', JSON.stringify(userInfo))
      //   const param = {
      //     username: this.loginParam.username,
      //     password: this.isEncrypt ? this.loginParam.password : encrypt(this.loginParam.password),
      //     code: this.loginParam.code
      //   }
      //   try {
      //     const { data } = await userApi.login(param, 1)
      //     localStorage.setItem('token', JSON.stringify(data.token))
      //     localStorage.setItem('name', JSON.stringify(data.name))
      //     localStorage.setItem('dept', JSON.stringify(data.dept))
      //     // this.isCodeShow && (this.visible = true)
      //     if(this.isCodeShow) {
      //       this.visible = true
      //     } else {
      //       this.$router.push('/')
      //       this.$message.success('登录成功', 1)
      //     }
      //     // this.$router.push('/')
      //     // this.$message.success('登录成功', 1)
      //   } catch({ message }) {
      //     this.$message.error(message)
      //     localStorage.removeItem('token')
      //   }
      // } else {
      //   try {
      //     const { data } = await userApi.login(this.loginParam, 0)
      //     localStorage.setItem('token', JSON.stringify(data.token))
      //     localStorage.setItem('name', JSON.stringify(data.name))
      //     localStorage.setItem('dept', JSON.stringify(data.dept))
      //     if(this.isCodeShow) {
      //       this.visible = true
      //     } else {
      //       this.$router.push('/')
      //       this.$message.success('登录成功', 1)
      //     }
      //     // this.$router.push('/')
      //     // this.$message.success('登录成功', 1)
      //   } catch({ message }) {
      //     this.$message.error(message)
      //     localStorage.removeItem('token')
      //   }
      // }
    },
    resetPassword() {
      this.isLogin = false
      this.resetParam = {
        mobile: this.loginParam.username,
        newPassword: '',
        captcha: ''
      }
    },
    changeRemember (e) {
      this.remember = e.target.checked
    },
    changePassword (e) {
      this.loginParam.password = e.target.value
      this.isEncrypt = false
    },
    handleOk() {
      localStorage.setItem('isTrusted', 'y')
      this.$router.push('/')
      this.$message.success('登录成功', 1)
    },
    handleCancel() {
      localStorage.removeItem('isTrusted')
      this.$router.push('/')
      this.$message.success('登录成功', 1)
    },
    async getCaptcha() {
      try {
          this.disabled = true
          this.timer = setInterval(() => {
            if(this.i === 0) {
              this.disabled = false
              this.i = 60
              clearInterval(this.timer)
              this.timer = null
            } else {
              this.i--
            }
          }, 1000)
          await sendCaptcha({
            url: '/sendCaptcha',
            method: 'POST',
            data: createFormData({
              mobile: this.loginParam.username
            })
          })
      } catch(e) {
        console.log(e);
      }
      // await userApi.getCaptcha(this.loginParam.username)
    },
    async getCaptcha1() {
      try {
          this.disabled1 = true
          this.timer = setInterval(() => {
            if(this.i1 === 0) {
              this.disabled1 = false
              this.i1 = 60
              clearInterval(this.timer)
              this.timer = null
            } else {
              this.i--
            }
          }, 1000)
          await sendCaptcha({
            url: '/sendCaptcha',
            method: 'POST',
            data: createFormData({
              mobile: this.loginParam.username
            })
          })
      } catch(e) {
        console.log(e);
      }
      // await userApi.getCaptcha(this.loginParam.username)
    },
    async resetP() {
      try {
        const { message } = await updatePassword(this.resetParam)
        this.$message.success(message)
      } catch {

      }
    },
    changeLang(locale) {
      this.lang = locale
      localStorage.setItem('lang', locale)
      this.$i18n.locale = locale
      document.title = this.$t('documentTitle')
    }
  }
}
</script>

<style lang="less" scoped>
  .login-wrap {
    margin: 0 auto;
    width: 360px;
    border-radius: 5px;
    box-shadow: 0 5px 15px -5px rgba(0,0,0,.5);
    background-color: #ffffff;
    .login-inner {
      padding: 30px;
      position: relative;
    }
  }
  .login-title {
    text-align: center;
    h2 {
      font-weight: bold;
      color: #1890ff;
    }
  }
  /deep/ .ant-input-suffix {
    display: none;
  }
  .footer {
    // background-color: rgba(0,0,0,.4);
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    color: #ddd;
    display: flex;
    justify-content: center;
    a {
      color: #ddd;
    }
  }
  .ant-dropdown-link {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .disabled {
    color: #ddd;
    cursor: not-allowed;
  }
</style>
